export default function authHeader() {
    console.log("auth true");
    return {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
    };
}
